import PropTypes from "prop-types";
import React from "react";
import styles from "./ChapterControlsInactiveSlider.css";

export default function ChapterControlsInactiveSlider(props) {
  if (props.hideProgressBarProgress) return null;
  return (
    <div className={styles.root}>
      <div className={styles.sliderBackground}>
        <div
          className={styles.sliderForeground}
          style={{
            width: `${(props.time / props.duration) * 100}%`,
          }}
        />
      </div>
    </div>
  );
}

ChapterControlsInactiveSlider.propTypes = {
  duration: PropTypes.number.isRequired,
  hideProgressBarProgress: PropTypes.bool.isRequired,
  time: PropTypes.number.isRequired,
};
